// extracted by mini-css-extract-plugin
module.exports = {"hidden":"v4Warning_hidden__EK5fb","textEmphasis":"v4Warning_textEmphasis__0AsIy","warningWrap":"v4Warning_warningWrap__3hEr_"};